import { Box, Divider, Group, Stack, Text } from '@mantine/core'
import React from 'react'
import ReportItem from '../ReportItem'

interface EnforcementCaseProps {
  number: number
  item: any
}

const formatAmount = (amount: any) => {
  if (!amount || amount === '' || amount === null || amount === undefined) {
    return amount
  }
  return `¥${amount}`
}

const formatPartiesInfo = (partiesInfo: any[]) => {
  if (!partiesInfo || !Array.isArray(partiesInfo) || partiesInfo.length === 0) {
    return '暂无'
  }

  return partiesInfo
    .map((party) => {
      const name = party.c_mc || '未知'
      const type = party.n_dsrlx || '未知'
      const position = party.n_ssdw || '未知'
      return `${name}（${type} - ${position}）`
    })
    .join('\n')
}

export default function EnforcementCase({ number, item }: EnforcementCaseProps) {
  const caseObj = item?.caseObj || item
  const cardBackgroundColor = '#ffffff'

  return (
    <Box
      style={{
        backgroundColor: cardBackgroundColor,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 'var(--mantine-radius-sm)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
        marginBottom: 'var(--mantine-spacing-xs)',
      }}
    >
      <Stack gap={'xs'} className={'text-gray-500'}>
        <Text size={'sm'} c={'dark'} fw={500}>
          案件（{number}）
        </Text>

        {/* 基本案件信息 */}
        <ReportItem name={'案件ID'} value={caseObj?.caseId} />
        <ReportItem name={'案号'} value={caseObj?.caseCode} />
        <ReportItem name={'案件类型'} value={caseObj?.caseType} />
        <ReportItem name={'案件身份'} value={caseObj?.casePosition} />
        <ReportItem name={'所属地域'} value={caseObj?.caseArea} />
        <ReportItem name={'案件标识'} value={caseObj?.caseIdentifier} />

        {/* 法院信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'经办法院'} value={caseObj?.courtName} />
        <ReportItem name={'法院层级'} value={caseObj?.courtLevel} />

        {/* 时间信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'立案时间'} value={caseObj?.caseRegTime} />
        <ReportItem name={'结案时间'} value={caseObj?.caseEndTime} />

        {/* 案件状态 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'案件状态'} value={caseObj?.caseStatus} />
        <ReportItem name={'结案方式'} value={caseObj?.caseEndMethod} />

        {/* 案由信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'立案案由'} value={caseObj?.filingReason} />
        <ReportItem name={'结案案由'} value={caseObj?.closingReason} />

        {/* 金额与其他信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem name={'申请执行标的金额'} value={formatAmount(caseObj?.applicationAmount)} />
        <ReportItem name={'案件变更编码'} value={caseObj?.caseChangeCode} />

        {/* 当事人信息 */}
        <Divider size="xs" color="gray.3" />
        <Box>
          <Group justify={'space-between'} align={'flex-start'}>
            <Text size={'sm'}>当事人信息</Text>
            <Text
              size={'sm'}
              style={{
                whiteSpace: 'pre-line',
                textAlign: 'right',
                maxWidth: '65%',
              }}
            >
              {formatPartiesInfo(caseObj?.partiesInfo)}
            </Text>
          </Group>
        </Box>
      </Stack>
    </Box>
  )
}
